import React from 'react';
import {Button} from "react-bootstrap";
import ConfirmDeleteModal, {CommonConfirmDeleteModalProps, CommonConfirmDeleteModalState} from "./ConfirmDeleteModal";

export default class DeleteManyCommentsWithButton extends React.Component<CommonConfirmDeleteModalProps, CommonConfirmDeleteModalState> {

    constructor(props: CommonConfirmDeleteModalProps) {
        super(props);
        this.state = {
            visible: false
        };
        this.open = this.open.bind(this);
        this.close = this.close.bind(this);
    }

    open() {
        this.setState({...this.state, visible: true});
    }

    close() {
        this.setState({...this.state, visible: false});
    }

    render() {
        return (
            <>
                <Button onClick={this.open} disabled={this.props.commentsToDelete === 0}>
                    Slett {this.props.commentsToDelete} kommentar{this.props.commentsToDelete === 1 ? '' : 'er'}
                </Button>
                <ConfirmDeleteModal visible={this.state.visible} close={this.close} {...this.props} />
            </>
        );
    }
}
